import { render, staticRenderFns } from "./PeriodResult.vue?vue&type=template&id=013a0680&"
import script from "./PeriodResult.vue?vue&type=script&lang=js&"
export * from "./PeriodResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports